import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { INavData } from '@coreui/angular-pro';

import { navItems, adminMakerMenu, adminCheckerMenu, corporateMakerMenu, corporateCheckerMenu, retailAdminMenu, supportAdminMenu } from './_nav';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent {
  navigationMenu: INavData[] = adminMakerMenu

  constructor(private auth: AuthService) {
    switch (auth.getRole())
    {
      case '1':
        this.navigationMenu = adminMakerMenu
        break
      case '2':
        break
      case '3':
        this.navigationMenu = corporateMakerMenu
        break
      case '4':
        this.navigationMenu = corporateCheckerMenu
        break
      case '5':
        this.navigationMenu = retailAdminMenu
        break
      case '6':
        this.navigationMenu = supportAdminMenu
        break
      case '7':
        this.navigationMenu = adminCheckerMenu
        break
    }
  }
}
